var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 14.5381C5.43457 14.5381 4.95117 14.333 4.54834 13.8789L0.783691 9.55762C0.402832 9.12549 0.285645 8.77393 0.285645 8.33447C0.285645 7.36035 1.02539 6.62793 2.02881 6.62793C2.58545 6.62793 2.99561 6.81836 3.34717 7.22119L6.02051 10.2974L11.4185 1.86719C11.8359 1.22266 12.2681 0.980957 12.9419 0.980957C13.938 0.980957 14.707 1.71338 14.707 2.68018C14.707 3.01709 14.5972 3.40527 14.3408 3.77881L7.62451 13.7544C7.26562 14.2891 6.73096 14.5381 6.0498 14.5381Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f54e7feebe5b5af2a542b4c9a65be62d.svg";
export { ForwardRef as ReactComponent };